export default "__VITE_ASSET__7739c51a__"